/**
 * Add class name to all the children recursively.
 *
 * @param parent
 * @param className
 * @param Function
 * @returns
 */
export function addClassToChildren(
  parent: Element | ChildNode | null | undefined,
  className: string,
  conditional?: (node: Element | ChildNode) => boolean
): void {
  if (!parent || !(parent instanceof Element)) {
    return;
  }

  if ((conditional && conditional(parent)) || !conditional) {
    if (parent.classList) {
      parent.classList.add(className);
    }
  }

  if (!parent.childElementCount) {
    return;
  }

  parent.childNodes.forEach((el) => addClassToChildren(el, className, conditional));
}
